import React from "react";
import styles from "./LoadingState.module.css";

function LoadingState({ message }) {
  return (
    <div className={styles.state}>
      <div className={styles.spinnerWrap}>
        <div className={styles.spinnerTrack} />
        <div className={`${styles.spinner} ${styles.spin}`} />
      </div>
      <div className={styles.textWrap}>
        <p className={styles.message}>{message}</p>
        <p className={styles.subtext}>This may take a few seconds</p>
      </div>
    </div>
  );
}

export default React.memo(LoadingState);
